import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import ResearchFocus from "@/components/site/ResearchFocus";
import Sensing from "@/components/site/Sensing";
import Approach from "@/components/site/Approach";
import Team from "@/components/site/Team";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main
      data-testid="landing-page"
      className="relative bg-[#050505] text-white font-body overflow-x-hidden"
    >
      <Navbar />
      <Hero />
      <About />
      <ResearchFocus />
      <Sensing />
      <Approach />
      <Team />
      <Contact />
      <Footer />
    </main>
  );
}
